import palette from "theme/palette";

export default theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.border}`,
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    height: '64px',
    zIndex: 1100
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  toolbar: {
    minHeight: '64px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flex: ' 1 1 auto'
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  toolbarCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  toolbarRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    marginLeft: theme.spacing(2),
    fontWeight: '500',
    fontSize: '1rem',
    lineHeight: 1.5
  },
  menuButton: {
    marginLeft: '-4px',
    padding: theme.spacing(1),
    '& .MuiIconButton-label': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '2px',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2px',
        '& svg': {
          width: '28px !important',
          height: '28px !important',
          marginBottom: '2px',
          filter: 'drop-shadow(0 0 0.5px currentColor)'
        },
        '& span': {
          fontSize: '14px !important',
          fontWeight: '600 !important',
          lineHeight: 1.2,
          marginTop: '2px'
        }
      }
    }
  },
  menuButtonLabel: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px'
  },
  notificationsButton: {
    marginLeft: 'auto'
  },
  accountButton: {
    marginLeft: 'auto',
    '&:hover': {
      borderRadius: '10%'
    }
  },
  agentNameDiv: {
    width: 'fit-content',
    border: `1px solid ${palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: palette.background.default,
    fontSize: '14px',
    padding: theme.spacing(0.5),
    fontWeight: 500,
    '&>div': {
      color: palette.primary.main,
    }
  }
});
